import { useNavigate, useParams } from "react-router-dom";
import { useAgendamentoPorId } from "../../../hooks/queries/agendamento/useAgendamentoPorId/useAgendamentoPorId";
import { useConsultarFatura } from "../../../hooks/queries/pagamento/useConsultarFatura/useConsultarFatura";
import { useAgendamentoStepIndicator } from "../../../hooks/useAgendamentoStepIndicator";
import { StatusPagamentoEnum } from "../../../enums/statusPagamento";
import { TipoAtendimentoEnum } from "../../../enums/tipoAtendimento";
import { Tracking } from "../../../services/Tracking";

const MODALIDADE_LABEL: Record<TipoAtendimentoEnum, string> = {
  [TipoAtendimentoEnum.LOJA]: "Loja",
  [TipoAtendimentoEnum.DOMICILIO]: "Delivery - Domicílio",
  [TipoAtendimentoEnum.ITINERANTE]: "Itinerante",
};

export const usePixConfirmationV2 = () => {
  const { uuidAgendamento } = useParams();
  const navigate = useNavigate();
  const stepIndicator = useAgendamentoStepIndicator();

  const { data: agendamento } = useAgendamentoPorId(uuidAgendamento ?? "");
  const { data: fatura } = useConsultarFatura(uuidAgendamento ?? "");

  const pagamento = fatura?.content?.find(
    (f) =>
      f.status === StatusPagamentoEnum.paid ||
      f.status === StatusPagamentoEnum.pending,
  );

  function handleRealizarAgendamento() {
    Tracking.userAction(
      "mapa:agendamento/pagamento/pix/confirmacao:clique-realizar-agendamento",
    );
    navigate(`/agendamento/${uuidAgendamento}/confirmar-horario`);
  }

  return {
    stepIndicator,
    servico: agendamento?.servico?.nome,
    modalidade: agendamento?.tipoAtendimento
      ? MODALIDADE_LABEL[agendamento.tipoAtendimento]
      : undefined,
    valorTotal: pagamento?.valorTotal,
    handleRealizarAgendamento,
  };
};
